import {
  $applyNodeReplacement,
  $createTextNode,
  DOMConversionMap,
  DOMConversionOutput,
  LexicalNode,
  SerializedTextNode,
  TextNode,
} from "lexical";

const ignoreMark = (element: HTMLElement): DOMConversionOutput | null => {
  const text = element.textContent;

  if (!text) {
    return null;
  }

  return {
    node: $createTextNode(text),
  };
};

export class BasicTextNode extends TextNode {
  static getType(): string {
    return "basic-text";
  }

  static clone(node: BasicTextNode): BasicTextNode {
    return new BasicTextNode(node.__text, node.__key);
  }

  static importDOM(): DOMConversionMap | null {
    const importers = TextNode.importDOM();

    return {
      ...importers,
      mark: () => ({
        conversion: ignoreMark,
        priority: 1,
      }),
    };
  }

  static importJSON(serializedNode: SerializedTextNode): TextNode {
    return super.importJSON(serializedNode);
  }

  isSimpleText(): boolean {
    return this.__type === "basic-text" && this.__mode === 0;
  }

  exportJSON(): SerializedTextNode {
    return {
      ...super.exportJSON(),
      type: "basic-text",
    };
  }
}

export function $createBasicTextNode(text: string): BasicTextNode {
  return $applyNodeReplacement(new BasicTextNode(text));
}

export function $createEmptySpaceTextNode(): BasicTextNode {
  return $createBasicTextNode(" ");
}

export function $isBasicTextNode(
  node: LexicalNode | null | undefined
): node is BasicTextNode {
  return node instanceof BasicTextNode;
}
